import { Component } from "@angular/core";
import { Location } from "@angular/common";
import { FormBuilder, FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import {
  API_URL_GET_DETAIL_MATCHING,
  API_URL_ADD_EVALUATION,
  API_URL_GET_UPLOAD_URL,
  API_URL_GET_LIST_POSTALS_INITIAL
} from "manager/http-constants";
import { forkJoin, Observable } from "rxjs";
import {
  API_RESPONSE,
  INPUT_INFORMATIONS_API_CONSTANT,
} from "src/app/shared/constant/api-constant";
import { CONSTANT, FILE_EXTENSION, IMAGE_EXTENSION, LOADING_KEY, MATCH_TYPE } from "src/app/shared/constant/constant";
import { MESSAGE_CODE } from "src/app/shared/constant/message-constant";
import { TOAST } from "src/app/shared/constant/primeng-constants";
import {
  LoadData,
  LoadingState,
} from "src/app/shared/html-parts/loading/loading-state";
import {
  MessageData,
  ToastMessageData,
} from "src/app/shared/html-parts/message-common/message-data";
import { CommonService } from "src/app/shared/service/common.service";
import { DbOperationService } from "src/app/shared/service/db-operation.service";
import { Validator } from "src/app/shared/validator/validator";
import { GENERATE_INPUT_TYPE } from "src/app/shared/generate/generate-input/constant";
import { PlatformComponent } from "../platform.component";
import { SESSION_KEY } from "../../../shared/constant/session-constants";
import { LoginService } from "src/app/shared/service/login.service";
import { FileUpload } from "primeng/fileupload";
import { MessageService } from "primeng/api";
import { HttpClient, HttpResponse } from "@angular/common/http";
import { map } from "rxjs/operators";

@Component({
  selector: "app-c701",
  templateUrl: "./c701.component.html",
  styleUrls: ["./c701.component.scss", "../platform.component.scss"],
})

/**
 * 提案登録(C701)
 * 提案登録確認(C702)
 */
export class C701Component extends PlatformComponent {
  // 画面.入力フォーム
  matchType: number = this.route.snapshot.queryParams.match_type;
  c701InputForm: FormGroup = this.matchType == 1 ? this.formBuilder.group({
    // 参加生徒・人数
    desired_people_number: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          "industrialization_report",
          "desired_people_number",
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 実施地域（市町村）
    implementation_city: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          "industrialization_report",
          "implementation_city",
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 実施場所
    implementation_location: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          "industrialization_report",
          "implementation_location",
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 実施日時
    implementation_datetime: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          "industrialization_report",
          "implementation_datetime",
          INPUT_INFORMATIONS_API_CONSTANT.DATE_TYPE
        ),
      ],
    }),
    // 印象・感想
    impression: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          "industrialization_report",
          "impression",
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    // アンケート回答フラグ
    survey_answer_flg: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          "industrialization_report",
          "survey_answer_flg",
          INPUT_INFORMATIONS_API_CONSTANT.RADIO_TYPE
        ),
      ],
    }),
    // 掲載可否フラグ
    publish_flg: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          "industrialization_report",
          "publish_flg",
          INPUT_INFORMATIONS_API_CONSTANT.RADIO_TYPE
        ),
      ],
    }),
    // 実施概要
    overview: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          "industrialization_report",
          "overview",
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    // 工夫したこと
    ingenuity: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          "industrialization_report",
          "ingenuity",
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    // 得られた成果
    results: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          "industrialization_report",
          "results",
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    // 写真
    image: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          "industrialization_report",
          "image",
          INPUT_INFORMATIONS_API_CONSTANT.FILE_TYPE
        ),
      ],
    }),
  }) : this.formBuilder.group({
    // 参加生徒・人数
    desired_people_number: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          "industrialization_report",
          "desired_people_number",
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),

    // 印象・感想
    impression: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          "industrialization_report",
          "impression",
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    // アンケート回答フラグ
    survey_answer_flg: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          "industrialization_report",
          "survey_answer_flg",
          INPUT_INFORMATIONS_API_CONSTANT.RADIO_TYPE
        ),
      ],
    }),
    // 掲載可否フラグ
    publish_flg: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          "industrialization_report",
          "publish_flg",
          INPUT_INFORMATIONS_API_CONSTANT.RADIO_TYPE
        ),
      ],
    }),
    // 実施概要
    overview: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          "industrialization_report",
          "overview",
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    // 工夫したこと
    ingenuity: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          "industrialization_report",
          "ingenuity",
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    // 得られた成果
    results: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          "industrialization_report",
          "results",
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    // 写真
    image: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          "industrialization_report",
          "image",
          INPUT_INFORMATIONS_API_CONSTANT.FILE_TYPE
        ),
      ],
    }),
  });

  // 課題IDを格納
  matchId: string = this.route.snapshot.queryParams.match_id;

  // 提案IDを格納
  // suggestId: string = this.route.snapshot.queryParams.suggest_id;

  // 課題・ソリューション詳細格納先
  detailTask: any;
  confirmationFlag: boolean = false;
  roleAuth: any;

  class_id: any = '';
  isLoading: boolean = true;
  fileName: string = ''
  fileUploadedImage: File;
  hasSelectedFile: boolean = true;
  fileUploadFlag: boolean = true;
  postalNoList: any = new Array();

  constructor(
    public route: ActivatedRoute,
    public commonService: CommonService,
    public dbOperationService: DbOperationService,
    public loadingState: LoadingState,
    private router: Router,
    private formBuilder: FormBuilder,
    private validator: Validator,
    private messageData: MessageData,
    private location: Location,
    public loginService: LoginService,
    private messageService: MessageService,
    private http: HttpClient,
  ) {
    super(route, commonService, dbOperationService, loadingState, loginService);

    this.router.navigate(["pages/platform/c701/" + this.inputType], {
      queryParams: {
        screenId: "c701",
        match_id: this.matchId,
        match_type: this.matchType
      },
    });
  }

  public ngOnInit() {
    this.getUserLoginInfo();
    this.getListPostalsInitial();
    this.getDetailTask();
  }

  public getUserLoginInfo() {
    this.loginService.getLoginUser().subscribe((response) => {
      this.loadingState.loadSleepEnd(0.3);
      if (this.commonService.checkNoneResponse(response)) {
        this.loginService.logout(MESSAGE_CODE.E90000);
        return;
      } else {
        this.class_id = response.body.class_id;
      }
    });
  }

  private getDetailTask(): void {
    this.loadingState.loadStart(API_URL_GET_DETAIL_MATCHING);

    this.dbOperationService
      .getNoTemplateDisplayData(API_URL_GET_DETAIL_MATCHING, this.matchId)
      .subscribe((response) => {
        this.loadingState.loadSleepEnd(0.3, API_URL_GET_DETAIL_MATCHING);
        if (this.commonService.checkInvalidValue(response)) {
          // 異常終了の場合
          // 異常終了メッセージ
          this.messageData.toastMessage(
            new ToastMessageData({
              severity: TOAST.WARN,
              summary: this.commonService.msg(MESSAGE_CODE.E00003),
              detail: this.commonService.msg(MESSAGE_CODE.E00026),
            })
          );
          this.location.back();
        } else if (this.commonService.checkNoneResponse(response)) {
          this.messageData.toastMessage(
            new ToastMessageData({
              severity: TOAST.WARN,
              summary: this.commonService.msg(MESSAGE_CODE.E00003),
              detail: this.commonService.msg(MESSAGE_CODE.E00026),
            })
          );
          this.location.back();
        } else {
          this.detailTask = response.body;
          this.isLoading = false;
        }
      });
  }

  public moveC702(): void {
    this.loadingState.customLoadStart(
      new LoadData({
        loadingText: CONSTANT.EMPTY_STRING,
        background_color: CONSTANT.EMPTY_STRING,
        opacity: 0.3,
      })
    );


    let task: Observable<any>[] = [
      /* 共通バリデーションチェック */
      this.dbOperationService.multiValidationResult(
        "suggest",
        this.c701InputForm.value
      ),
    ];

    // 非同期同時実行
    forkJoin(task).subscribe((dataList) => {
      // 画面ロードフラグをOFF(ロード終了)
      this.loadingState.loadEnd();

      // 提案登録確認(C702)へ遷移
      this.router.navigate(["pages/platform/c701/" + this.inputType], {
        queryParams: { screenId: "c702", match_id: this.matchId, match_type: this.matchType },
      });

      // 提案登録確認(C702)を表示する
      this.confirmationFlag = true;
    });
  }

  /**
   * 提案登録完了(C703)を表示する
   */
  public async moveC703(): Promise<void> {
    // 画面.入力フォームから入力内容を取得
    // ※値渡し
    let c701InputForm: any = JSON.parse(
      JSON.stringify(this.c701InputForm.value)
    );
    // ファイルが存在する場合はS3にアップロード
    if (this.fileUploadedImage) {
      await this.uploadFiletoS3(
        this.fileUploadedImage,
        "industrialization_report"
      );
    }

    // 課題・ソリューションID
    c701InputForm.match_id = this.matchId;

    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(LOADING_KEY.DATA_INSERT);

    // 登録タイプ判定
    if (GENERATE_INPUT_TYPE.NEW == this.inputType) {
      // 新規登録の場合

      // 提案登録を実施
      this.dbOperationService
        .insertData(API_URL_ADD_EVALUATION, c701InputForm)
        .subscribe((response) => {
          // 画面ロードフラグをOFF(ロード終了)
          this.loadingState.loadSleepEnd(0.3, LOADING_KEY.DATA_INSERT);

          // レスポンス結果を判定
          if (API_RESPONSE.SUCCESS == response.body.Message) {
            // 正常終了の場合

            // 提案登録完了(C433)へ遷移
            this.router.navigate(["pages/platform/c703"]);
          } else if (this.commonService.checkInvalidValue(response)) {
            // 異常終了の場合
            // 異常終了メッセージ
            this.messageData.toastMessage(
              new ToastMessageData({
                severity: TOAST.WARN,
                summary: this.commonService.msg(MESSAGE_CODE.E00003),
                detail: this.commonService.msg(MESSAGE_CODE.E00026),
              })
            );
            this.router.navigate(["pages/platform/c502"]);
          } else if (API_RESPONSE.FAIL == response.body.Message) {
            // 異常終了の場合

            // 異常終了メッセージ
            this.messageData.toastMessage(
              new ToastMessageData({
                severity: TOAST.ERROR,
                summary: this.commonService.msg(MESSAGE_CODE.E00002),
                detail: this.commonService.msg(MESSAGE_CODE.E00004),
              })
            );
            this.router.navigate(["pages/platform/c502"]);
            // 提案登録(C431)を表示する
            this.confirmationFlag = false;
          } else {
            // 提案上限の場合

            // 提案上限メッセージ
            this.messageData.toastMessage(
              new ToastMessageData({
                severity: TOAST.ERROR,
                summary: this.commonService.msg(MESSAGE_CODE.E00001),
                detail: response.body.Message,
              })
            );

            // 提案登録(C431)を表示する
            this.confirmationFlag = false;
          }
        });
    }
  }
  // remove fileUpload from list
  removeFile(file: File, uploader: FileUpload, colId) {
    const index = uploader.files.indexOf(file);
    uploader.remove(null, index);

    this.fileUploadedImage = null;
    this.fileName = ''

    this.c701InputForm.controls[colId].setValue(CONSTANT.EMPTY_STRING);
    this.c701InputForm.controls[colId].markAsDirty();
    this.hasSelectedFile = false;
  }

  uploadFile(event, controlId, fileUpload) {
    const fileObj: File = event.files[0];
    if (!fileObj) {
      return;
    }

    const fileExtension = fileObj.name.substring(
      event.files[0].name.lastIndexOf(CONSTANT.PERIOD)
    );
    let valid = true;

    if (
      !(
        IMAGE_EXTENSION.JPG == fileExtension ||
        IMAGE_EXTENSION.JPEG == fileExtension ||
        IMAGE_EXTENSION.PNG == fileExtension ||
        IMAGE_EXTENSION.JPG2 == fileExtension ||
        IMAGE_EXTENSION.JPEG2 == fileExtension ||
        IMAGE_EXTENSION.PNG2 == fileExtension
      ) &&
      (controlId == "image")
    ) {
      // Invalid image File

      this.messageService.add({
        severity: TOAST.ERROR,
        summary: this.commonService.msg(MESSAGE_CODE.E00009),
        detail: this.commonService.msg(
          MESSAGE_CODE.E00010,
          "JPEG形式（jpg・jpeg）、PNG形式（png）"
        ),
      });

      valid = false;
    } else if (fileObj.size > CONSTANT.MAX_FILE_SIZE) {
      if (
        controlId == "image"
      ) {
        this.messageService.add({
          severity: TOAST.ERROR,
          summary: this.commonService.msg(MESSAGE_CODE.E00009),
          detail: this.commonService.msg(MESSAGE_CODE.E00031, CONSTANT.MAX_FILE_SIZE_text),
        });
        valid = false;
      }
    } else if (this.checkFileNameLength(fileObj.name)) {
      const sumary = (
        controlId == "image"
      ) ? this.commonService.msg(MESSAGE_CODE.E00009) : this.commonService.msg(MESSAGE_CODE.E00033);
      this.messageService.add({
        severity: TOAST.ERROR,
        summary: sumary,
        detail: this.commonService.msg(MESSAGE_CODE.E00035),
      });
      valid = false;
    }
    if (!valid) {
      // If file is invalid
      // Clear the button operation status
      fileUpload.clear();
      if (
        controlId == "image"
      ) {
        this.fileUploadedImage = null;
      }
      this.fileName = ''
      this.c701InputForm.controls[controlId].setValue(null);
      // Processing is terminated
      return;
    } else {

      this.c701InputForm.controls[controlId].setValue(
        event.files[0].name
      );
      this.fileName = event.files[0].name
      if (
        controlId == "image"
      ) {
        this.fileUploadedImage = fileObj;
      }
    }

    if (!this.fileUploadFlag) {
      fileUpload.clear();
    }
  }

  public async uploadFiletoS3(fileUploaded: File, tableId) {
    const uploadInfo: any = await this._getUploadInfo(
      fileUploaded.name,
      tableId
    );
    if (
      uploadInfo.url === undefined ||
      uploadInfo.url === null ||
      uploadInfo.url.length === 0 ||
      uploadInfo.url.indexOf("s3.amazonaws.com") === -1
    ) {
      this.messageService.add({
        severity: TOAST.ERROR,
        summary: this.commonService.msg(MESSAGE_CODE.I00005),
        detail: this.commonService.msg(MESSAGE_CODE.E00002),
      });
      return;
    }

    await this._uploadToS3(uploadInfo, fileUploaded);
  }

  private _getUploadInfo(filename, tableId) {
    const fileType = 'image';
    const colName = 'image';
    const url = this.commonService.url(API_URL_GET_UPLOAD_URL);
    return this.http
      .get(url, {
        params: {
          tablename: tableId,
          filetype: fileType,
          colname: colName,
          filename: encodeURIComponent(filename),
          code: "",
        },
      })
      .toPromise();
  }

  private _uploadToS3(uploadInfo, fileUpload) {
    return new Promise<any>((resolve) => {
      const uploadUrl = uploadInfo.url;
      const fields: any = uploadInfo.fields;

      const formData = new FormData();
      Object.entries(uploadInfo.fields).forEach(([k, v]) => formData.append(k, String(v)));
      formData.append("file", fileUpload, fileUpload.name);

      this.http
        .post(uploadUrl, formData, { observe: "response" })
        .pipe(map((res: HttpResponse<any>) => res))
        .subscribe((res) => resolve(res));
    });
  }
  public formatDateJapan() {
    let date = new Date(this.c701InputForm.value?.implementation_date);
    let lang = 'en',
      year = date.toLocaleString(lang, { year: 'numeric' }),
      month = date.toLocaleString(lang, { month: 'numeric' }),
      day = date.toLocaleString(lang, { day: 'numeric' });
    return `${year}年 ${month}月 ${day}日`;
  }
  moveC701() {
    this.router.navigate(["pages/platform/c701/" + this.inputType], {
      queryParams: { screenId: "c701", matchId: this.matchId, matchType: this.matchType },
    });

    this.confirmationFlag = false;
  }
  public getListPostalsInitial(): void {
    this.postalNoList = new Array();
    this.loadingState.loadStart(API_URL_GET_LIST_POSTALS_INITIAL);

    this.dbOperationService
      .getNoTemplateData(API_URL_GET_LIST_POSTALS_INITIAL, {}, true)
      .subscribe((response) => {
        if (!this.commonService.checkNoneResponse(response)) {
          this.postalNoList = response.body;
        } else {
          this.postalNoList = new Array();
        }

        this.loadingState.loadSleepEnd(0.3, API_URL_GET_LIST_POSTALS_INITIAL);
      });
  }
  public getNameByValue(dataList: any[], value: any): string | undefined {
    const found = dataList.find(item => item.value === value);
    return found ? found.name : undefined;
  }
}
